import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { useState } from 'react'
import Config from 'config'
import PasswordRequirements from './PasswordRequirements'

export function Input ({
  reference,
  error,
  label,
  icon,
  placeholder,
  type,
  maxLength = 255,
  required = false,
  ...inputProps
}) {
  const [internalType, setInternalType] = useState(type || 'text')
  return (
    <div className="w-full">
      {label && (
        <label
          htmlFor={label}
          className={`flex mb-1 text-xs font-semibold text-left text-main-${Config.PLATFORM}`}
        >
          {label}&nbsp;
          {required && (
            <span className="inline-block mx-1 text-red">*</span>
          )}
        </label>
      )}

      <input
        {...inputProps}
        type={internalType}
        ref={reference}
        maxLength={maxLength}
        placeholder={placeholder}
        required={required}
        className={`shadow-soft-white border border-gray-lines focus:border-main-${Config.PLATFORM} bg-input w-full py-3 px-7 mb-2 sm:mb-5 relative z-10 text-left text-xs font-normal rounded-lg placeholder-gray cursor-pointer transition-all duration-200 outline-none hover:border-main-${Config.PLATFORM} hover:outline-none hover:shadow-inner focus:outline-none focus:shadow-focus active:outline-none`}
      />

      {type === 'password' && (
        <div className="relative flex justify-end mr-4 bottom-9 md:bottom-12">
          {internalType === 'password' && (
            <FaEye
              onClick={() => setInternalType('text')}
              className={`cursor-pointer text-main-${Config.PLATFORM} text-sm z-20`}
            />
          )}

          {internalType !== 'password' && (
            <FaEyeSlash
              onClick={() => setInternalType('password')}
              className={`cursor-pointer text-main-${Config.PLATFORM} text-sm z-20`}
            />
          )}
        </div>
      )}

      {error && (error.password_register || error.new_password) && (
        <PasswordRequirements errors={error} />
      )}

      {error && (
        <div className="relative text-left text-red left-2 sm:top-0 md:-top-3 text-xxs">
          {error.message}
        </div>
      )}
    </div>
  )
}
